<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-breadcrumb>
                <ot-breadcrumb-item :to="{ path: '/' }">首页</ot-breadcrumb-item>
                <ot-breadcrumb-item href="/">活动管理</ot-breadcrumb-item>
                <ot-breadcrumb-item>活动列表</ot-breadcrumb-item>
                <ot-breadcrumb-item>活动详情</ot-breadcrumb-item>
            </ot-breadcrumb>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-breadcrumb%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-breadcrumb-item%20%3Ato%3D%22%7B%20path%3A%20'%2F'%20%7D%22%3E%E9%A6%96%E9%A1%B5%3C%2Fot-breadcrumb-item%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-breadcrumb-item%20href%3D%22%2F%22%3E%E6%B4%BB%E5%8A%A8%E7%AE%A1%E7%90%86%3C%2Fot-breadcrumb-item%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-breadcrumb-item%3E%E6%B4%BB%E5%8A%A8%E5%88%97%E8%A1%A8%3C%2Fot-breadcrumb-item%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-breadcrumb-item%3E%E6%B4%BB%E5%8A%A8%E8%AF%A6%E6%83%85%3C%2Fot-breadcrumb-item%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-breadcrumb%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>
